import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { User } from "@/lib/store/auth-enhanced";
import type { Salon } from "@/lib/store/salon";

interface UserProfileCardProps {
  user: User;
  currentSalon?: Salon | null;
}

export function UserProfileCard({ user, currentSalon }: UserProfileCardProps) {
  return (
    <div className="bg-muted/50 rounded-lg p-4 mb-4">
      <div className="flex items-center space-x-3">
        <Avatar className="h-12 w-12">
          <AvatarImage src="" alt={`${user.firstName} ${user.lastName}`} />
          <AvatarFallback className="bg-indigo-100 dark:bg-indigo-800/30 text-indigo-600 dark:text-indigo-400 font-medium">
            {user.firstName.charAt(0)}
            {user.lastName.charAt(0)}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1">
          <div className="font-medium text-foreground">
            {user.firstName} {user.lastName}
          </div>
          <div className="text-sm text-muted-foreground">{user.email}</div>
          {currentSalon && (
            <div className="text-xs text-muted-foreground mt-1">{currentSalon.name}</div>
          )}
        </div>
      </div>
    </div>
  );
}
